import {
  isPasswordMatch,
  passwordMatchIssue,
  passwordSchema,
  standardStringSchema,
} from "@/schemas"
import { z } from "zod"

export const resetPasswordSchema = z
  .object({
    confirmPassword: standardStringSchema,
    password: passwordSchema,
  })
  // Why partial? To allow the confirmPassword validation to display without having to complete the entire form.
  // See https://github.com/colinhacks/zod/issues/479#issuecomment-854822386
  .partial()
  .superRefine((data, ctx) => {
    if (
      !isPasswordMatch({
        confirmPassword: data.confirmPassword,
        password: data.password,
      })
    ) {
      ctx.addIssue({
        ...passwordMatchIssue,
      })
    }
  })

export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>
